<template>
  <div class="balance-card p-2">
    <!-- Skeleton Loader -->
    <div v-if="loading" class="balance-header m-4">
      <div class="row w-100">
        <div class="col-12 col-md-8 d-flex flex-column justify-content-center">
          <div class="skeleton-text skeleton-label"></div>
          <div class="skeleton-amount-container">
            <div class="skeleton-text skeleton-currency"></div>
            <div class="skeleton-text skeleton-amount"></div>
            <div class="skeleton-toggle"></div>
          </div>
        </div>
        <div class="col-12 col-md-4 d-flex align-items-center justify-content-md-end mt-3 mt-md-0">
          <div class="skeleton-button skeleton-add-balance"></div>
        </div>
      </div>
    </div>

    <!-- Actual Content -->
    <div v-else class="balance-header m-4">
      <div class="row w-100">
        <div class="col-12 col-md-8 d-flex flex-column justify-content-center">
          <div class="balance-label">Available Balance</div>
          <div class="balance-amount">
            <span class="currency">IDR</span> {{ formattedBalance }}
            <button class="icon-btn" @click="toggleVisibility">
              <i v-if="visible" class="fas fa-eye-slash eye-icon"></i>
              <i v-else class="fas fa-eye eye-icon"></i>
            </button>
          </div>
        </div>
        <div
          class="col-12 col-md-4 d-flex align-items-center justify-content-md-end mt-3 mt-md-0"
        >
          <button 
            v-if="canShowAddBalance" 
            class="add-balance" 
            @click="$emit('add-balance')"
          >
            + Add Balance
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { canAddBalance, isAkunDemo } from "@/utils/role-utils";

export default {
  name: "BalanceCard",
  props: {
    balance: {
      type: Number,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  components: {},
  data() {
    return {
      visible: true,
    };
  },
  computed: {
    formattedBalance() {
      if (!this.visible) return "••••••••••••";
      return this.balance.toLocaleString("en-US");
    },
    canShowAddBalance() {
      // Hide add balance button if company_name === 'AKUN DEMO'
      if (isAkunDemo()) {
        return false;
      }
      return canAddBalance();
    },
  },
  methods: {
    toggleVisibility() {
      this.visible = !this.visible;
    },
  },
};
</script>

<style scoped>
.add-balance {
  width: 142px;
  height: 40px;
  padding: 8px 16px;
  gap: 10px; /* Ignored unless using flex or grid */
  border-radius: 4px;

  background: linear-gradient(180deg, #43bb75 0%, #1c9762 100%);
  border: 1px solid var(--Green-100, #128050);
  box-shadow: inset 0px 2px 1px 0px #ffffff40;

  color: white;
  font-weight: 600;
  font-family: "IBM Plex Sans Devanagari", sans-serif;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.75%;
  vertical-align: middle;
  text-align: center;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.balance-card {
  background: #fff;
  border-radius: 16px;
  padding: 24px 32px;
  display: flex;
  flex-direction: column;
  color: #000 !important;
}
.balance-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.balance-label {
  color: #000 !important;
  font-size: 14px;
}
.balance-amount {
  font-size: 2.5rem;
  font-weight: bold;
  letter-spacing: 1px;
  display: flex;
  align-items: center;
  font-family: "IBM Plex Sans Devanagari", sans-serif;
  font-weight: 700;
  font-size: 40px;
  line-height: 48px;
  letter-spacing: 0;
  vertical-align: middle;
  color: var(--Dark-Green, #022326);
}
.currency {
  margin-right: 8px;
}
.icon-btn {
  background: none;
  border: none;
  margin-left: 8px;
  cursor: pointer;
  font-size: 1.2rem;
}
.add-balance-btn {
  height: 100px;
  width: 90px;
  font-size: 1rem;
}

/* Skeleton Loader Styles */
.skeleton-text,
.skeleton-button,
.skeleton-toggle {
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: 8px;
}

.skeleton-label {
  width: 120px;
  height: 16px;
  margin-bottom: 12px;
}

.skeleton-amount-container {
  display: flex;
  align-items: center;
  gap: 8px;
}

.skeleton-currency {
  width: 40px;
  height: 48px;
}

.skeleton-amount {
  width: 280px;
  height: 48px;
}

.skeleton-toggle {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}

.skeleton-add-balance {
  width: 142px;
  height: 40px;
  border-radius: 4px;
}

@keyframes shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}
</style>
